import { connect } from "react-redux";
import MarketingImage from "./MarketingImage";
import { isFeatureActive } from "../../../../state/modules/features";

function mapStateToProps(state) {
  return {
    isGradientBackground: isFeatureActive(state, "stc-gradient-background")
  };
}

export default connect(mapStateToProps)(MarketingImage);



// WEBPACK FOOTER //
// ./template/components/Navigation/LargeSecondaryNavigation/MarketingImage/index.js